<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import DocsNavBar from "./components/DocsNavBar.vue";

const store = useStore();
const windowWidth = ref(window.innerWidth);

// Detectar cambios de tamaño
const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", updateWindowWidth);
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  document.body.classList.remove("bg-gray-100");
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowWidth);
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  document.body.classList.add("bg-gray-100");
});

</script>

<template>
  <div class="container-fluid vh-100">
    <div class="row h-100">
      <!-- Navbar lateral -->
      <div class="col-12 col-md-2">
        <DocsNavBar />
      </div>
      <!-- Contenido principal -->
      <main class="col-12 col-md-10 overflow-auto p-7">

        <!-- Sección del manual de usuario (Registro de Horas) -->
        <hr>
        <h3> Manual de Usuario - Registro de Horas <br> <img src="../../assets/img/user-manual/UserManual-4.gif" alt=""> </h3>
        <section class="mt-4">
          <hr>
          <p class="text-gray-700">
            <u><b>  Última Revisión:</b></u> 27/03/2025 <br><br>
            Bienvenid@ a esta breve guía que le ayudará a conocer el proceso en la captura de horas dentro de esta nueva plataforma.<br>
          </p>
          <hr>

          <div class="mt-4">
            <h4 class="text-xl font-semibold"> <i class="bi bi-caret-right-fill"></i> Registro de Horas.</h4>
          </div>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 1 - Accede al panel principal</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualHours-1.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Una vez que haya ingresado correctamente, verá el siguiente panel de control, donde podrá realizar diferentes actividades</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 2 - Accede al panel de captura de horas</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualHours-2.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">En la sección denominada <b>"Registrar Tiempo <i class="bi bi-arrow-right"></i> Registrar Horas"</b> podrá acceder al formulario y panel de control para la capturas de horas facturables y no facturables.</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 3 - Formulario de registro de horas</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualHours-3.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Dentro del formulario de captura de horas, podemos encontrar los diferentes días a la semana, en estos podemos registrar las horas totales, facturables y no facturables, así como especificar si son de planta o no.</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 4 - Captura de horas</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualHours-4.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Una vez introducidas las horas facturables y no facturables, deberá hacer clic el botón «Guardar» situado en la parte superior derecha del formulario de registro.</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 5 - Horas capturadas</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualHours-5.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Para comprobar que las horas se han registrado correctamente, podemos ir a la parte inferior del formulario de registro de horas, debajo de él, veremos un segundo apartado, donde encontraremos los registros que se han realizado.</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 6 - Opciones adicionales</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualHours-6.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">En este apartado podemos modificar, borrar y filtrar por (Proyecto, Cliente o Actividad), las diferentes horas que se han capturado a lo largo del tiempo.</p>
            </div>
          </div><br>
        </section>
        <!-- Final - Sección del manual de usuario (Registro de Horas) -->

      </main>
    </div>
  </div>
</template>

<style scoped>
  /* Estilos adicionales para asegurar que todo se vea bien */
  main {
    min-height: 100vh; /* Asegurar que el contenido tenga la altura completa */
  }

 h3 {
   text-align: center;
 }
 .bi-caret-right-fill {
  color: #db7535;
 }

 .bi-caret-right {
  color: #db7535;
 }

 .card {
  background: #f5f2f2 ;
 }

</style>
